import * as tslib_1 from "tslib";
import { lazyOnItemNavigation } from 'owa-addins-core';
import { isAddInFeatureEnabled } from 'owa-addins-feature-flags';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
export default function updateAddinOnItemNavigation(selectionType, hostItemIndex) {
    if (hostItemIndex === void 0) { hostItemIndex = null; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = isMailFeatureEnabled('rp-addins') &&
                        isAddInFeatureEnabled('addin-persistentTaskPane');
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, lazyOnItemNavigation.import()];
                case 1:
                    _a = (_b.sent())(selectionType, hostItemIndex);
                    _b.label = 2;
                case 2:
                    _a;
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=updateAddinOnItemNavigation.js.map